module.exports = __webpack_public_path__ + "static/section3-b1eb44896c22f52a5119e310ed1208bf.png";